import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
export function InnerIntentionsPrivacyPage() {
  return <div className="min-h-screen bg-[#0a0014] text-white pt-28 pb-24 overflow-hidden relative" data-id="element-1222">
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-fuchsia-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-1223" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-pink-600/20 rounded-full blur-[120px] pointer-events-none" data-id="element-1224" />

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-1225">
        {/* Back link */}
        <Link to="/apps/inner-intentions" className="inline-flex items-center gap-2 text-fuchsia-300 hover:text-fuchsia-200 font-medium mb-8 transition-colors" data-id="element-1226">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-1227" />
          Back to Inner Intentions
        </Link>

        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-center mb-12" data-id="element-1228">
          <div className="w-14 h-14 rounded-2xl bg-fuchsia-950/50 border border-fuchsia-500/30 flex items-center justify-center mx-auto mb-6 shadow-[0_0_20px_rgba(236,72,153,0.3)]" data-id="element-1229">
            <ShieldCheckIcon className="w-7 h-7 text-fuchsia-300" data-id="element-1230" />
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-pink-400 via-fuchsia-400 to-purple-400 mb-3 drop-shadow-[0_0_10px_rgba(236,72,153,0.5)]" data-id="element-1231">
            Privacy Policy
          </h1>
          <p className="text-fuchsia-300/70 font-medium" data-id="element-1232">
            Inner Intentions — Effective May 12, 2026
          </p>
        </motion.div>

        {/* Content */}
        <div className="bg-black/40 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-fuchsia-900/50" data-id="element-1233">
          <div className="prose prose-invert max-w-none text-fuchsia-100/70 text-sm leading-relaxed space-y-6" data-id="element-1234">
            <p data-id="element-1235">
              Inner Intentions ("we," "our," or "us") respects your privacy and
              is committed to protecting your personal information. This Privacy
              Policy explains how information may be collected, used, and
              protected when using the Inner Intentions mobile application and
              related services.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1236">
              Information We May Collect
            </h3>
            <p data-id="element-1237">Depending on how you use the app, we may collect:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-1238">
              <li data-id="element-1239">Account information such as email address or username</li>
              <li data-id="element-1240">Basic profile information</li>
              <li data-id="element-1241">App usage activity and preferences</li>
              <li data-id="element-1242">
                Device information such as device type, operating system, and
                crash reports
              </li>
              <li data-id="element-1243">
                Anonymous analytics data used to improve app performance and
                user experience
              </li>
            </ul>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1244">
              How We Use Information
            </h3>
            <p data-id="element-1245">Information collected may be used to:</p>
            <ul className="list-disc pl-5 space-y-1" data-id="element-1246">
              <li data-id="element-1247">Provide and improve app functionality</li>
              <li data-id="element-1248">Personalize user experience</li>
              <li data-id="element-1249">Save preferences and progress</li>
              <li data-id="element-1250">Monitor app stability and performance</li>
              <li data-id="element-1251">Respond to support requests or feedback</li>
              <li data-id="element-1252">Prevent abuse, spam, or misuse of the platform</li>
            </ul>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1253">
              Data Sharing
            </h3>
            <p data-id="element-1254">We do not sell personal information to third parties.</p>
            <p data-id="element-1255">
              Some third-party services used by the app, such as analytics,
              authentication, subscriptions, advertising, or cloud hosting
              providers, may process limited data necessary for app
              functionality.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1256">
              User Content
            </h3>
            <p data-id="element-1257">
              Questions, responses, profile content, and interactions within the
              app may be stored to provide gameplay, social features,
              personalization, or saved progress. Users are responsible for the
              content they choose to share inside the app.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1258">
              Children's Privacy
            </h3>
            <p data-id="element-1259">
              Inner Intentions is not directed toward children under the age of
              13. We do not knowingly collect personal information from children
              under 13.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1260">
              Data Security
            </h3>
            <p data-id="element-1261">
              We take reasonable measures to help protect user information and
              maintain platform security. However, no system can guarantee
              complete security.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1262">
              Account & Data Removal
            </h3>
            <p data-id="element-1263">
              Users may request account or data deletion by contacting: <br data-id="element-1264" />
              <strong data-id="element-1265">Email:</strong> trippinwithmandy@gmail.com
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1266">
              Changes to This Policy
            </h3>
            <p data-id="element-1267">
              This Privacy Policy may be updated periodically. Continued use of
              the app after updates constitutes acceptance of the revised
              policy.
            </p>

            <h3 className="text-fuchsia-300 font-bold text-base mt-8 mb-3" data-id="element-1268">
              Contact
            </h3>
            <p data-id="element-1269">
              For questions regarding this Privacy Policy, contact: <br data-id="element-1270" />
              <strong data-id="element-1271">Trippin' with Mandy Email:</strong>{' '}
              trippinwithmandy@gmail.com
            </p>
          </div>
        </div>
      </div>
    </div>;
}